export default "__VITE_ASSET__CLAXoGYA__"